module.exports = __webpack_public_path__ + "img/dc03b88.svg";